<template>
  <div class="bg-light py-4">
    <div class="container">
      <div class="coupon">
        <div class="container">
          <div class="coupon mt-4 text-center text">
            <h1 class="my-2">
              <strong>父親節全館8折優惠</strong>
            </h1>

            <small>使用時間至2020/09/01</small>
            <h2 class="my-3">優惠碼</h2>
            <h3>Thankyoufather</h3>
          </div>
        </div>
      </div>
      <hr />
      <div class="coupon">
        <div class="container">
          <div class="coupon mt-4 text-center text">
            <h1 class="my-2">
              <strong>天天都有優惠</strong>
            </h1>

            <small>使用時間至倒店為止</small>
            <h2 class="my-3">優惠碼</h2>
            <h3>RedHomeMusic</h3>
          </div>
        </div>
      </div>
      <hr />
      <div class="coupon">
        <div class="container">
          <div class="coupon mt-4 text-center text">
            <h1 class="my-2">
              <strong>我愛您5566</strong>
            </h1>

            <small>使用時間至52056/05/06</small>
            <h2 class="my-3">優惠碼</h2>
            <h3>Iloveyou5566</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>